import constants from '../../../../constants';

export const evalStatus = (request: any) =>
  constants.procedureStatus.graduatedCertificated.find(
    (s: any) => s.name === request?.status.status
  );
